const countEquipmentPlateUseCase = (repository) => async () => {
    return await repository();
}

export default countEquipmentPlateUseCase;